import Hero from './components/Hero';

export default function Home() {
  return (
    <div className="relative w-full min-h-screen bg-white">
      <main>
        <Hero />
      </main>
    </div>
  );
}